import { AuthPageLayout } from "Components/Auth/Shared/AuthPageLayout";
import { SetPasswordForm } from "Components/Auth/SetPasswordPage/SetPasswordForm";
import { useNavigate } from "Navigation/useNavigate";
import { useSearchParams } from "Navigation/useSearchParams";
import { resetError, setUnauthenticatedUrl } from "State/Auth/AuthReducer";
import { SetPasswordStep } from "State/Auth/Models/AuthStateModels";
import {
  setPasswordAsync,
  setPasswordSetStep,
} from "State/Auth/Passwords/SetPasswordsState";
import type { RootStateType } from "State/Store";
import { Resources, useResource } from "Translations/Resources";
import { resolveStartPage } from "Utils/UrlUtils";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const COMPONENT_RESOURCES = Resources.Pages.Content.SetPassword;

export const SetPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { token } = useParams();
  const { t } = useResource();

  const { isLoading, user, unauthenticatedUrl, errorCode, setPasswordStep } =
    useSelector((e: RootStateType) => e.auth);

  useEffect(() => {
    dispatch(resetError());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setPasswordSetStep(SetPasswordStep.Password));
    };
  }, [dispatch]);

  useEffect(() => {
    if (!isLoading && !!user && setPasswordStep === SetPasswordStep.Success) {
      const from = {
        pathname: resolveStartPage(user, unauthenticatedUrl) || "/",
      };

      if (unauthenticatedUrl !== null) {
        dispatch(setUnauthenticatedUrl(null));
      }

      navigate(from);
    }
  }, [
    isLoading,
    user,
    navigate,
    unauthenticatedUrl,
    dispatch,
    setPasswordStep,
  ]);

  const isCreate = searchParams.get("isCreate") === "true";
  const title = isCreate
    ? t(COMPONENT_RESOURCES.CreateNewPassword)
    : t(COMPONENT_RESOURCES.ResetPassword);

  const handleSubmit = (password: string) => {
    if (!token) {
      return;
    }
    dispatch(setPasswordAsync.request({ token, password }));
  };

  return (
    <AuthPageLayout title={title} isLoading={isLoading} pageType="other">
      <SetPasswordForm
        isLoading={isLoading}
        errorCode={errorCode}
        onSubmit={handleSubmit}
      />
    </AuthPageLayout>
  );
};
